import React from 'react'
import Header from '../../Component/Header';
import Footer from '../../Component/Footer';
import AccountSidebar from '../../Component/AccountSidebar';

class ReverseWithdrawals extends React.Component {
   
    render() {
        var content = (
            <div>
                <div className="my-account">

                    <div className="container">

                        <AccountSidebar />
                        <div className="account-right-container">


                            <div className="transaction">

                                <div className="acount-inner">
                                    <h3>Reverse Withdrawal</h3>
                                </div>


                                <div style={{padding: '8px 6px', background: '#eeeeee'}}>
                                    <iframe height="485"
                                        allowtransparency="true"
                                        frameBorder="0"
                                        scrolling="no"
                                        className="withdrawIframe"
                                        src="https://geoffbanks.wufoo.com/forms/?formname=ztf31qw101o6p8&embed=1&embedKey=ztf31qw101o6p8741162&entsource=&referrer=http:wuslashwuslashlocalhost:8100wuslash&scrolling=true#public" >
                                        <a href="https://geoffbanks.wufoo.com/forms/?formname=ztf31qw101o6p8&embed=1&embedKey=ztf31qw101o6p8741162&entsource=&referrer=http:wuslashwuslashlocalhost:8100wuslash&scrolling=true#public">
                                        </a>
                                    </iframe >
                                </div>








                            </div>




                        </div>

                    </div>
                </div>

                <Footer />
            </div>

        );
        return (
            <div>
                {content}
            </div>

        )
    }
}


export default ReverseWithdrawals;